import React from 'react'
import { withStyles } from 'material-ui/styles'
import compose from 'recompose/compose'
import TextField from 'material-ui/TextField'
import Slide from 'material-ui/transitions/Slide'
import List, { ListItem, ListItemText, ListItemIcon } from 'material-ui/List'
import { CurrenciesIcon } from 'assets/currencies'
import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer'
import VirtualList from 'react-virtualized/dist/commonjs/List'
import Button from 'material-ui/Button'
import { orderBy } from 'lodash'
import Dialog, {
  DialogContent,
  DialogTitle,
  DialogActions,
} from 'material-ui/Dialog'

const styles = theme => ({
  DialogContentRoot: {
    display: 'flex',
    flex: '1 1 auto',
    flexDirection: 'column',
  },
  listItem: {
    paddingTop: 0,
    paddingBottom: 0,
  },
})

class DialogCurrencySelector extends React.Component {
  state = {
    keywords: '',
    currencies: [],
  }

  componentWillMount = () => {
    this.updateCurrencies(this.props)
  }

  componentWillReceiveProps = nextProps => {
    this.updateCurrencies(nextProps)
  }

  updateCurrencies = props => {
    this.setState({
      currencies: orderBy(props.currencies, ['priority'], ['desc']),
    })
  }

  handleFilterChange = e => {
    this.setState({ keywords: e.target.value })
  }

  handleCancel = () => {
    this.props.onRequestClose()
  }

  handleChange = code => {
    this.props.onChange(code)
    this.props.onRequestClose()
  }

  getResults = () => {
    const { keywords, currencies } = this.state
    const inputValue = keywords.trim().toLowerCase()
    const inputLength = inputValue.length
    var results =
      inputLength === 0
        ? currencies
        : currencies.filter(
            c => c.name.toLowerCase().slice(0, inputLength) === inputValue
          )
    return results
  }

  render() {
    const { open, classes } = this.props
    const { selectedCurrency, keywords } = this.state
    const currencies = this.getResults()
    const _rowRenderer = ({ key, index, style }) => (
      <ListItem
        button
        className={classes.listItem}
        key={key}
        style={style}
        onClick={() => this.handleChange(currencies[index].code)}
      >
        <ListItemIcon>
          <CurrenciesIcon currency={currencies[index].code} />
        </ListItemIcon>
        <ListItemText inset primary={currencies[index].name} />
      </ListItem>
    )
    return (
      <Dialog
        fullScreen
        onRequestClose={this.handleCancel}
        transition={Slide}
        open={open}
      >
        <DialogTitle>Select a currency</DialogTitle>
        <DialogContent classes={{ root: classes.DialogContentRoot }}>
          <TextField
            autoFocus
            id="filter"
            label="Filter"
            value={this.state.keywords}
            onChange={this.handleFilterChange}
            margin="normal"
          />
          <List>
            <AutoSizer>
              {({ width, height }) => (
                <VirtualList
                  ref={ref => (this.List = ref)}
                  height={height}
                  currencies={currencies}
                  rowCount={currencies.length}
                  rowHeight={48}
                  rowRenderer={_rowRenderer}
                  keywords={keywords}
                  selectedCurrency={selectedCurrency}
                  width={width}
                />
              )}
            </AutoSizer>
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

// const mapStateToProps = state => ({
//   isOpen: state.config.DialogCurrencySelectorOpen,
// })
//
// const mapDispatchToProps = dispatch => ({
// })

export default compose(
  withStyles(styles)
  // connect(mapStateToProps, mapDispatchToProps)
)(DialogCurrencySelector)



// WEBPACK FOOTER //
// ./src/components/DialogCurrencySelector.js